export const MEAL_LABELS = {
  breakfast: 'Frühstück',
  lunch: 'Mittagessen',
  dinner: 'Abendessen',
  snacks: 'Snacks',
};

export const MEAL_ORDER = ['breakfast', 'lunch', 'dinner', 'snacks'];
